import React from "react";
import { Select } from "antd";
import PropTypes, { string } from 'prop-types';
import { PlaceHolder } from "./styles";
import { CustomSelectBox } from '../../../../CommonComponents/commonStyles';

let dropDownOptions = [];
const Option = Select.Option;

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      size: "large",
      children: this.props.menu,
      optionsAnt: [],
      optionInfo: ["A", "B", "C", "D", "E", "F"],
      info: false
    };
    this.OptionInfoHandler = this.OptionInfoHandler.bind(this);
    this.configureOptions = this.configureOptions.bind(this);
  }

  OptionInfoHandler(index) {
    this.setState({ info: true });
  }

  componentDidMount() {
    this.configureOptions(this.props)
   let multiSelectNode = document.querySelector("input[id^='txnSummarySelectMultiSelect']")
   if(multiSelectNode)
   {
    multiSelectNode.setAttribute("id", "txnSummarySelectMultiSelectInput");
    multiSelectNode.setAttribute("aria-label","multi select")
   }

  }

  configureOptions = async (newProps) => {
    var optionsAnt = newProps.options ? newProps.options : null;
    var newOption =
      optionsAnt &&
      optionsAnt.map((x, index) => (
        <Option key={index} value={x}>
          {x}
        </Option>
      ));
    dropDownOptions = newOption;
    this.setState({
      optionsAnt: newOption
    });

  }

  componentWillReceiveProps(nextProps) {
    this.configureOptions(nextProps);
    if (this.props.updatedMenu !== nextProps.updatedMenu) {
    }
  }

  render() {
    return (
      <CustomSelectBox
        data-test="transaction-multi-select"
        id="txnSummarySelectMultiSelect"
        aria-label="transaction select dropdown"
        mode="tags"
        showArrow={true}
        placeholder={<PlaceHolder>-Select-</PlaceHolder>}
        onChange={this.props.handleDropper}
        value={this.props.selectedVal}
        onInputKeyDown={(e) => {
          e.preventDefault()
        }}
        getPopupContainer={() => document.getElementById("txnSummarySelectMultiSelect")}
        dropdownClassName="advisorSel"
        width="200"
      >
        {dropDownOptions}
      </CustomSelectBox>
    );
  }
}

MultiSelect.propTypes = {
  handleDropper: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  selectedVal: PropTypes.arrayOf(PropTypes.string)
}
export default MultiSelect;
